import { render, staticRenderFns } from "./dashboardWidget.vue?vue&type=template&id=8e095fc0&scoped=true&"
import script from "./dashboardWidget.vue?vue&type=script&lang=js&"
export * from "./dashboardWidget.vue?vue&type=script&lang=js&"
import style0 from "./dashboardWidget.vue?vue&type=style&index=0&id=8e095fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e095fc0",
  null
  
)

export default component.exports